import { render, staticRenderFns } from "./mainView.vue?vue&type=template&id=72eaa57c"
import script from "./mainView.vue?vue&type=script&lang=js"
export * from "./mainView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports